import { Alert } from "@mui/material";

export default function VerifyPriceAnomalyBanner({ notice }) {
  if (!notice?.message) return null;

  const severity = notice.type === "error" ? "error" : notice.type === "empty" ? "success" : "warning";

  return <Alert severity={severity}>{notice.message}</Alert>;
}
